import { render, staticRenderFns } from "./EmailForwarder.vue?vue&type=template&id=93305a66&"
import script from "./EmailForwarder.vue?vue&type=script&lang=js&"
export * from "./EmailForwarder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93305a66')) {
      api.createRecord('93305a66', component.options)
    } else {
      api.reload('93305a66', component.options)
    }
    module.hot.accept("./EmailForwarder.vue?vue&type=template&id=93305a66&", function () {
      api.rerender('93305a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Forwarders/EmailForwarder.vue"
export default component.exports